















import {
  Vue,
  Component,
  Prop,
} from "vue-property-decorator";
import { Util } from "@/utils";
import NavDataService from "@/api/service/app/navdata-service";
import { Subject, Subscription } from "rxjs";
import { Environment } from "@/environments/environment";
import { postMessageToIframe, getSysUrl } from "@/utils/menu-path/menu-path";

import { appConfig } from "@/config/appConfig";

@Component({
  components: {},
})
export default class CardView extends Vue {
     @Prop() public name!: string;
     @Prop() public noneHeaderBorder?: boolean;
}
